import 'vue3-easy-data-table/dist/style.css'

export default {
    name: 'GlobalTable',
    props: {
      data: Array,
      columns: Array,
    },
  };